module.exports = __webpack_public_path__ + "static/img/notebooks.6f7af05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notebooks.jpg
// module id = 298
// module chunks = 0